import {Component, Input} from '@angular/core';
import {BaseModalComponent, DonationProgram} from 'brewbill-lib';
import {ModalController} from '@ionic/angular';

@Component({
    selector: 'bb-select-donation-program',
    templateUrl: './select-donation-program.component.html',
    styleUrls: ['./select-donation-program.component.scss'],
})
export class SelectDonationProgramComponent extends BaseModalComponent {
    @Input() availableDonationPrograms: DonationProgram[];

    constructor(modalController: ModalController) {
        super(modalController);
    }
}
